const dropicons = [
    {
        label: 'Plus Minus',
        value: 'fa-solid fa-plus_fa-solid fa-minus'
    },
    {
        label: 'Arrow Up Down',
        value: 'fas fa-chevron-down_fas fa-chevron-up'
    },
    {
        label: 'Arrow Up Down Alt',
        value: 'fas fa-sort-down_fas fa-sort-up'
    },
    {
        label: 'Hands Up Down',
        value: 'fas fa-hand-point-down_fas fa-hand-point-up'
    },
    {
        label: 'Arrow Up Down With Circle',
        value: 'fas fa-chevron-circle-down_fas fa-chevron-circle-up'
    }
];

export default dropicons;